import React from "react";
import TimePicker from "../../TimePicker";

export default function TimePickerWrapper(props) {
  return <TimePicker {...props} />;
}
